import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface FormResponse {
  status: number,
  errors: string[],
  isSent: boolean,
}

@Injectable({
  providedIn: 'root'
})
export class CommonFormService {

  WEB_ORDER_URL = environment.baseUrl + '/form/process/';
  NEW_FORM_URL = environment.apiBaseUrl + '/realty/forms/';// Эндпоинт на новую обработку форм
  constructor(private http: HttpClient) { }

  sendWebOrder(form: Record<string, string|number|null>, type: string): Observable<FormResponse> {
    return this.http.post<FormResponse>(this.NEW_FORM_URL + type, form);
  }
}
